import _ from 'lodash';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';

const createField = (name, caption, dataFn) => ({
  name,
  caption,
  data: dataFn,
});

const availableFields = [
  createField('name', 'customer_field.title.name', c => c.name),
  createField('email', 'customer_field.title.email', c => c.email),
  createField('phone', 'customer_field.title.phone', c => c.phone),
  createField('remoteId', 'customer_field.title.remote_id', c => c.remote_id),
];

export default {
  props: {
    fields: {
      type: Array,
      default: () => [
        'remoteId',
        'name',
        'email',
      ],
    },
    headerCustomerOpen: {
      type: Boolean,
      default: false,
    },
    model: Object,
  },
  components: {
    'box-widget': BoxWidget,
  },
  computed: {
    visibleFields() {
      return this.fields
        .map(name => availableFields.find(f => f.name === name))
        .filter(f => !!f)
        .filter(f => f.name !== 'remoteId' || _.get(this.model, 'remote_id', null))
        .map(f => ({
          name: this.$t(f.caption),
          value: f.data(this.model, this.$t.bind(this), this),
        }));
    },
  },
  methods: {
    isEmpty(value) {
      return _.isEmpty(value) ? '-' : value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/customer-info/CustomerInfo.js